const modules = {
    advertisement: 'advertisement',
    reported_to_post: 'reported_to_post',
    market_place: 'market_place',
    account_type_user: 'account_type_user',
    account_type_pro: 'account_type_pro',
    account_type_facility: 'account_type_facility',
    roles: 'roles',
    admin_users: 'admin_users',
    sparkfeed: 'sparkfeed',
    insurance:'insurance',
    certificate:'certificate',
} as const;

const permissions = {
    READ: 'READ',
    WRITE: 'WRITE',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
} as const;

const errorMsg = 'You are not allowed to perform this action';
export { modules, permissions, errorMsg };